module.exports = __webpack_public_path__ + "static/media/Image-21.8a48ed8b.svg";